import { useQuery } from '@tanstack/react-query'
import { ClientReportsService, TClientReportsServiceOptions } from '../services/client_reports.service'
import { ReportClientDto } from '../types'
import { DEFAULT_CACHE_TIME, defaultQueryOptions } from './common'

export const useClientReports = (
  locationName: string,
  lupId: string,
  reportName: string,
  options: TClientReportsServiceOptions,
  hookOptions?: { cacheEnabled?: boolean; enabled?: boolean }
) => {
  const { cacheEnabled = false, enabled = true } = hookOptions || {}
  return useQuery<ReportClientDto>({
    queryKey: ['clientReports', locationName, lupId, reportName, options.filter],
    queryFn: () => ClientReportsService.get(locationName, lupId, reportName, options),
    ...defaultQueryOptions,
    enabled,
    ...(cacheEnabled ? { staleTime: DEFAULT_CACHE_TIME, cacheTime: DEFAULT_CACHE_TIME } : {}),
  })
}
